module.exports = __webpack_public_path__ + "static/media/hostastay-icon.94f9e2c8.png";